export default __webpack_public_path__ + "static/media/lisieux17.2adfece5.jpg";